// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MultilingualString } from "./MultilingualString";
import {
  MultilingualStringFromJSON,
  MultilingualStringFromJSONTyped,
  MultilingualStringToJSON,
  MultilingualStringToJSONTyped,
} from "./MultilingualString";

/**
 *
 * @export
 * @interface Overview
 */
export interface Overview {
  /**
   *
   */
  url: string;
  /**
   *
   */
  nameObject?: MultilingualString | null;
}

/**
 * Check if a given object implements the Overview interface.
 */
export function instanceOfOverview(value: object): value is Overview {
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function OverviewFromJSON(json: any): Overview {
  return OverviewFromJSONTyped(json, false);
}

export function OverviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): Overview {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
    nameObject:
      json["nameObject"] === undefined
        ? undefined
        : json["nameObject"] === null
        ? null
        : MultilingualStringFromJSON(json["nameObject"]),
  };
}

export function OverviewToJSON(json: any): Overview {
  return OverviewToJSONTyped(json, false);
}

export function OverviewToJSONTyped(
  value?: Overview | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    url: value["url"],
    nameObject: MultilingualStringToJSON(value["nameObject"]),
  };
}
